export const environment = {
  api_redsys: 'https://dev.scubamedic.segursub.com',
  url_front: 'https://dev.scubamedic.segursub.com',
  url: '/api/',
  url_terms_documents: '/condicionados',
  GOOGLE_ID: '',
};
